import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router';
import { FORM_ERROR } from 'final-form'

import { companyUpdated } from '../../actions/company';
import { loadPaymentData, savePaymentData2 } from '../../actions/payment';
import NavBarConfig from '../../components/NavBarConfig';
import NotFound from '../../components/NotFound';
import CompanyPaymentForm from './components/CompanyPaymentForm';

const messages = defineMessages({
  BACK: {
    id: 'CompanyPaymentEditPage.BACK',
    defaultMessage: 'Zurück',
  },
  EDIT_ACCOUNT: {
    id: 'CompanyPaymentEditPage.EDIT_ACCOUNT',
    defaultMessage: 'Nutzerkonto bearbeiten',
  },
  CREATE_ACCOUNT: {
    id: 'CompanyPaymentEditPage.CREATE_ACCOUNT',
    defaultMessage: 'Nutzerkonto anlegen',
  },
});

class CompanyPaymentEditPage extends React.Component {
  componentWillMount() {
    const { company } = this.props;
    if (!company.payment && company.hasPaymentData) {
      this.props.loadPaymentData();
    }
  }

  render() {
    const {
      user,
      company,
      companyMembership,
      onSubmit,
      routes,
      intl: { formatMessage },
    } = this.props;

    if (!user.is_admin && !companyMembership.is_owner) {
      return <NotFound />;
    }

    return (
      <div style={{ minHeight: '80vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px 20px' }}>
        <NavBarConfig
          customerList={{ company_id: company.id }}
          currentRouteName={routes[routes.length - 1].name}
        />
        <div style={{
          background: 'rgba(255, 255, 255, 0.85)',
          backdropFilter: 'blur(12px)',
          WebkitBackdropFilter: 'blur(12px)',
          borderRadius: '24px',
          boxShadow: '0 10px 40px rgba(0, 0, 0, 0.08)',
          padding: '40px 50px',
          maxWidth: '650px',
          width: '100%',
          border: '1px solid rgba(255, 255, 255, 0.5)'
        }}>
          <Link to={`/company/${company.id}/payment/`} onMouseDown={e => e.preventDefault()} style={{ color: 'var(--primary-color, #0275d8)', textDecoration: 'none', display: 'inline-block', marginBottom: '20px', fontWeight: '500' }}>
            <i className="fa fa-arrow-left" style={{ marginRight: '8px' }}></i> {formatMessage(messages.BACK)}
          </Link>
          <h3 style={{ color: '#1f2937', fontSize: '28px', fontWeight: '700', marginBottom: '24px', letterSpacing: '-0.5px' }}>
            {formatMessage(
              company.hasPaymentData ? messages.EDIT_ACCOUNT : messages.CREATE_ACCOUNT
            )}
          </h3>
          <div style={{ marginTop: '30px' }}>
            <CompanyPaymentForm
              onSubmit={onSubmit}
              initialValues={company.payment}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    user: state.auth.user
  }),
  (dispatch, props) => ({
    onSubmit: async formData => {
      const data = await savePaymentData2(props.params.companyId, formData);
      if (data.response) {
        const company = data.response;
        dispatch(companyUpdated(company));
        dispatch(push(`/company/${company.id}/payment/`));
      } else {
        return { [FORM_ERROR]: data.error[Object.keys(data.error)[0]] };
      }
    },
    loadPaymentData: () =>
      loadPaymentData(props.company.id).then(response =>
        dispatch(companyUpdated({ ...props.company, payment: response }))
      ),
  }))(injectIntl(CompanyPaymentEditPage));
